import { LineCalendarData } from "../../models/CalendarData";

export class AddBidListData {
  static readonly type = "[BidListData] add";
  constructor(public payload: LineCalendarData[]) {}
}

export class RemoveBidListData {
  static readonly type = "[BidListData] remove";
  constructor() {}
}
